module.exports = __webpack_public_path__ + "img/TCRB.a4ea47d1.png";